import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Empregador } from '../../api.service';
import { ModalPesquisaListaComponent } from '../../shared/modal-pesquisa-lista.component';

@Component({
  selector: 'app-modal-pesquisa-empregador',
  standalone: true,
  imports: [ModalPesquisaListaComponent],
  templateUrl: './modal-pesquisa-empregador.component.html'
})
export class ModalPesquisaEmpregadorComponent {
  @Input() aberta = false;
  @Input() termo = '';
  @Input() empregadores: Empregador[] = [];
  @Input() rotuloEmpregador: (item: unknown) => string = () => '';
  @Input() detalheEmpregador: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() selecionar = new EventEmitter<Empregador>();
  @Output() limpar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  selecionarEmpregador(item: unknown) {
    this.selecionar.emit(item as Empregador);
  }
}
